import styled from 'styled-components';

import { variableFontRegular } from 'styles/theme/text';
import { GlobalPricingInfo } from 'productTemplate/components/buyBar/GlobalPricingInfo';

export const BuyBarGlobalPricingInfo = styled(GlobalPricingInfo)`
  margin: 0;
  text-align: left;

  ${GlobalPricingInfo.InnerDiv} {
    ${variableFontRegular({ size: '11px', height: '14px' })}
  }

  ${variableFontRegular({ height: '12.5px', size: '9.5px' })};
  @media (min-width: ${({ theme }) => theme.breakpoints.mediumLarge}px) {
    text-align: center;
    ${GlobalPricingInfo.InnerDiv} {
      ${variableFontRegular({ size: '10px', height: '14px' })}
    }

    ${variableFontRegular({ height: '14.5px', size: '11.5px' })};
  }
`;
